<template><div>

	<div class="tab-pane-plan-wrapper">

		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>

		<!-- если запущен процесс или нет доступа -->
		<template v-if="!Access">
			<div class="text-center margin-top-5">
				<div v-if="serviceStatus && (serviceStatus.loader || serviceStatus.timer)" style="margin: 80px auto">
					<span v-if="serviceStatus['loader']" class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }} <img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" /></span>
					<span v-else-if="serviceStatus['timer']" class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }} <font-awesome-icon icon="clock" style="margin-left: 6px" /></span>
					<span v-else class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }}</span>
				</div>
				<template v-else>
					<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
					<br>
					<span class="w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
				</template>
			</div>
		</template>
		<!-- нет активного процесса и есть права -->
		<template v-else>
			<!-- включение/выключение -->
			<div class="tab-pane-command-wrapper" v-if="ipLocalData && 'value' in ipLocalData">
				<div class="control-wrapper">
					<input type="checkbox" class="w5-checkbox-field" v-model="localSwitcher" style="display: none" />
					<label @click="onSwitcherClick" :class="{ 'disable': !Access || Status !== 'active' }" style="display: inline-block; height: 3em; line-height: 3em;">
						{{ 'datacenter/local_net' | ftc }}
					</label>
				</div>
			</div>

			<!-- данные по локальной сети -->
			<div v-if="IpData && IpData.ip" class="tab-pane-local-net">
				<span v-if="IpData.ip">
					<strong>{{ 'ippool/ippool' | ftc }}: </strong>
					<span>{{ IpData.ip }}</span>
				</span>
				<span v-if="IpData.netmask">
					<strong>{{ 'ippool/netmask' | ftc }}: </strong>
					<span>{{ IpData.netmask }}</span>
				</span>
				<span v-if="IpData.mac">
					<strong>MAC: </strong>
					<span>{{ IpData.mac }}</span>
				</span>
			</div>
			
			<!-- инструкция -->
			<div class="tab-pane-command-wrapper">
				<h4>{{ 'datacenter/local_net' | ftc }}</h4>
				<p v-withSafeTags="localeFtc('service/local_net_description')"></p>
			</div>
		</template>
	</div>

</div></template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'tabLocalIp',
	//=========================================================================
	// данные переденные родителем
	//=========================================================================
	props: [
		'ipLocalData', 'data', 'vdsId', 'access', 'status', 'serviceStatus', 'parentError'
	],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			// данные поля
			IpData: null,
			// доступ
			Access: false,
			Status: null,
			Error: '',
			localErrorMessage: '',
			// переключатель локальной сети
			localSwitcher: false,
			localSwitcherProcessing: false
		}
	},
	//=========================================================================
	// при создании компонента
	//=========================================================================
	created() {
		this.IpData = this.data
		this.Access = this.access
		this.Status = this.status
		this.Error = this.parentError

		this.localSwitcher = false
		if (this.ipLocalData && typeof this.ipLocalData === 'object' && 'value' in this.ipLocalData)
			this.localSwitcher = this.ipLocalData.value
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		onSwitcherClick() {
			if (!this.vdsId) return
			// если контрол задизаблен - ничего не делаем
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// если мы в процессе изменения - ничего не делаем
			if (this.localSwitcherProcessing) return

			// ставим флаг начала процесса
			this.localSwitcherProcessing = true
			// делаем запрос на изменение
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'])
					{
						// данные формы
						let _post = {
							'_csrf': _dt['_csrf']
						}
						_post[_dt['model']] = {
							'ip_local': !this.localSwitcher ? 1 : 0
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.localSwitcherProcessing = false
								// проверка ответа
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok' && _dt['request'] && _dt['request']['request_id'])
								{
									// меняем значение
									this.localSwitcher = !this.localSwitcher
									// на это всем, никаких рефрешей не нужно,
									// ибо придет пуш, и по нему система сама все обновит
									// а пока просто сообщим
									this.$emit('successMessage', 'main/updated')
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// обнулим флаг процесса
								this.localSwitcherProcessing = false
								// ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// обнулим флаг процесса
					this.localSwitcherProcessing = false
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// обнулим флаг процесса
					this.localSwitcherProcessing = false
					// ошибка
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'data': function(data) {
			this.IpData = data
		},
		'access': function(access) {
			this.Access = access
		},
		'status': function(status) {
			this.Status = status
		},
		'parentError': function(value) {
			this.Error = value
		},
		'ipLocalData': function(data, oldData) {
			this.localSwitcher = false
			if (this.ipLocalData && typeof this.ipLocalData === 'object' && 'value' in this.ipLocalData)
				this.localSwitcher = this.ipLocalData.value
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
.tab-pane-local-net {
	display: flex;
	display: -webkit-box;
	display: -webkit-flex;
	justify-content: flex-start;
	-webkit-justify-content: flex-start;

	margin: 15px 0;
	padding: 15px;
	border: 1px solid #eee;
	border-radius: 4px;
}
.tab-pane-local-net > span {
	margin-right: 20px;
}
@media (max-width: 767px) {
	.tab-pane-local-net {
		flex-direction: column;
	}
	.tab-pane-local-net > span {
		margin-right: 0;
	}
}
</style>



// WEBPACK FOOTER //
// localIp.vue?e83bb430